export default "/images/education_development_sm.jpg?2ca25258d0318c83c24afb5a46f82546";